export function encodeLabelhash(hash) {
  return "[".concat(hash.slice(2), "]");
}
//# sourceMappingURL=encodeLabelhash.js.map